<template>
<div>
  <div class="word_5" ref="previewDom" style="padding-bottom:50px">
    <div class="a4">
      <h1 style="font-size:50px;margin-top:140px">贵州省黄果树杯优质工程</h1>
      <h1 style="font-size:50px;letter-spacing: 24px;">申报表</h1>
      <div id="condition"
        style="font-size:28px;margin-top:180px;text-align:start;margin-left:100px;font-family:'仿宋'"
      >工程名称： {{ alldata.Contractorinfo.projectNname }}</div>
      <div
        style="font-size:28px;margin-top:40px;text-align:start;margin-left:100px;font-family:'仿宋'"
      >推荐单位：{{ alldata.Contractorinfo.RecommendedUnit }}</div>
      <div
        style="font-size:28px;margin-top:40px;text-align:start;margin-left:100px;font-family:'仿宋'"
      >申报单位：{{ alldata.Contractorinfo.ReportingUnit }}</div>
      <p style="font-size:28px;margin-top:100px;">{{ alldata.Contractorinfo.Filling_date?alldata.Contractorinfo.Filling_date:'年 月 日' }}</p>
      <p style="font-size:28px">贵州省黄果树杯评选委员会办公室制</p>
    </div>
    <div class="a4">
      <p style="font-size:34px;margin-top:20px;line-height:100px">申报表填写说明</p>
      <div
        style="text-align:start;letter-spacing: 4px;font-family:'仿宋';font-size:26px;line-height:40px"
      >
        1、本表由申报单位即申报工程的承建单位填写并装订完成。联合申报工程由联合承建单位中排序第一位的负责完成。参建单位不填写本表，申报工程涉及到的参建单位内容，由该工程的承建单位统一填写。
        <br />2、如工程有多家参建单位，每个参建单位都要填写“参建单位简况”栏。
        <br />3、“承建单位和参建单位公章”栏，由承建单位和参建单位在各自单位框内加盖单位公章，并填写盖章日期，公章名称必须与企业法人营业执照名称一致。
        <br />4、“建设单位意见”栏，由申报工程建设单位对工程建设全过程的有关情况签署质量评价意见。
        <br />5、“使用单位意见”栏，由直接使用单位和申报工程管理单位对竣工验收交付使用后的使用情况签署质量评价意见。
        <br />6、“设计单位意见”栏，由申报工程的设计单位对工程是否满足设计要求签署评价意见。
        <br />7、“监理单位意见”栏，由申报工程的监理单位对工程施工全过程是否符合设计要求及相关规范、标准的有关情况签署评价意见。
        <br />8、“推荐单位意见”栏，由申报工程的初审单位签署意见。
        <br />
      </div>
    </div>
    <div class="a4">
      <div
        class="box"
        style="width:720px;text-align:start;padding:6px;position: relative;"
      >
        <span style="font-size:24px;font-family:仿宋">承建单位和参建单位公章：</span>
        <br />
        <div style="height:340px">
          <span style="font-size:24px;font-family:仿宋;line-height:50px">1、承建单位:</span>
          <div class="box position" style="width:280px;height:1px;top:100px;"></div>
          <div class="box position" style="width:180px;height:180px;top:140px;">
            <span class="position" style="width:100%;top:140px;font-family:仿宋;font-size:24px">（盖 章）</span>
            <span class="position" style="width:100%;top:200px;font-family:仿宋;font-size:24px">年 月 日</span>
          </div>
        </div>
        <div>
          <span style="font-size:24px;font-family:仿宋;line-height:50px">2、参建单位:</span>
          <div style="display:flex;justify-content: space-evenly;margin-top:30px">
            <div style>
              <div class="box" style="width:280px;height:1px;"></div>
              <div
                class="box"
                style="width:180px;height:180px;margin:40px auto;position: relative;"
              >
                <span
                  class="position"
                  style="width:100%;top:140px;font-family:仿宋;font-size:24px"
                >（盖 章）</span>
                <span
                  class="position"
                  style="width:100%;top:200px;font-family:仿宋;font-size:24px"
                >年 月 日</span>
              </div>
            </div>
            <div>
              <div class="box" style="width:280px;height:1px;"></div>
              <div
                class="box"
                style="width:180px;height:180px;margin:40px auto;position: relative;"
              >
                <span
                  class="position"
                  style="width:100%;top:140px;font-family:仿宋;font-size:24px"
                >（盖 章）</span>
                <span
                  class="position"
                  style="width:100%;top:200px;font-family:仿宋;font-size:24px"
                >年 月 日</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <span style="font-size:24px;font-family:仿宋;line-height:50px">2、参建单位:</span>
          <div style="display:flex;justify-content: space-evenly;margin-top:30px">
            <div style>
              <div class="box" style="width:200px;height:1px;"></div>
              <div
                class="box"
                style="width:150px;height:150px;margin:40px auto;position: relative;"
              >
                <span
                  class="position"
                  style="width:100%;top:100px;font-family:仿宋;font-size:24px"
                >（盖 章）</span>
                <span
                  class="position"
                  style="width:100%;top:150px;font-family:仿宋;font-size:24px"
                >年 月 日</span>
              </div>
            </div>
            <div>
              <div class="box" style="width:200px;height:1px;"></div>
              <div
                class="box"
                style="width:150px;height:150px;margin:40px auto;position: relative;"
              >
                <span
                  class="position"
                  style="width:100%;top:100px;font-family:仿宋;font-size:24px"
                >（盖 章）</span>
                <span
                  class="position"
                  style="width:100%;top:150px;font-family:仿宋;font-size:24px"
                >年 月 日</span>
              </div>
            </div>
            <div>
              <div class="box" style="width:200px;height:1px;"></div>
              <div
                class="box"
                style="width:150px;height:150px;margin:40px auto;position: relative;"
              >
                <span
                  class="position"
                  style="width:100%;top:100px;font-family:仿宋;font-size:24px"
                >（盖 章）</span>
                <span
                  class="position"
                  style="width:100%;top:150px;font-family:仿宋;font-size:24px"
                >年 月 日</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div class="a4">
      <span
        style="font-family:'仿宋';font-size:30px;line-height:40px;display:block;"
      >一、承建单位（申报单位）简况</span>
      <div class="th">
        <div class="box justify-center" style="width:220px;height:40px;font-size:24px">单位名称</div>
        <div class="box justify-center" id="condition" style="width:500px;height:40px;font-size:24px">{{ alldata.Contractorinfo.Contractor_name1 }}</div>
      </div>
      <div class="th">
        <div class="box justify-center" style="width:220px;height:40px;font-size:24px">联系电话</div>
        <div class="box justify-center" id="condition" style="width:500px;height:40px;font-size:24px">{{ alldata.Contractorinfo.phone11 }}</div>
      </div>
      <div class="th">
        <div class="box justify-center" style="width:220px;height:40px;font-size:24px">通信地址</div>
        <div class="box justify-center" id="condition" style="width:500px;height:40px;font-size:24px">{{ alldata.Contractorinfo.mailing_address1 }}</div>
      </div>
      <div class="th">
        <div class="box justify-center" style="width:220px;height:40px;font-size:24px">邮政编码</div>
        <div class="box justify-center" id="condition" style="width:500px;height:40px;font-size:24px">{{ alldata.Contractorinfo.Postal1 }}</div>
      </div>
      <div class="th">
        <div class="box justify-center" id="condition" style="width:220px;height:60px;font-size:20px;">
          主营范围及其
          <br />资质等级
        </div>
        <div class="box justify-center" id="condition" style="width:500px;height:60px;font-size:20px">{{ alldata.Contractorinfo.Qualification_level1 }}</div>
      </div>
      <div class="th">
        <div
          class="box justify-center"
          id="condition"
          style="width:70px;height:200px;display:flex;align-items:center;justify-content:center;font-size:24px"
        >
          法定
          <br />代表
          <br />人
        </div>
        <div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:101px;font-size:24px">姓 名</div>
            <div class="box justify-center" id="condition" style="width:500px;height:101px;font-size:24px">{{ alldata.Contractorinfo.name21 }}</div>
          </div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:100px;font-size:24px">联系电话</div>
            <div class="box justify-center" id="condition" style="width:500px;height:100px;font-size:24px">{{ alldata.Contractorinfo.phone21 }}</div>
          </div>
        </div>
      </div>
      <div class="th">
        <div
          class="box justify-center"
          style="width:70px;height:347px;font-size:24px"
        >
          申报
          <br />工作
          <br />联系
          <br />人
        </div>
        <div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:71px;font-size:24px">姓 名</div>
            <div class="box justify-center" id="condition" style="width:500px;height:71px;font-size:24px">{{ alldata.Contractorinfo.name31 }}</div>
          </div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:70px;font-size:24px">工作部门</div>
            <div class="box justify-center" id="condition" style="width:500px;height:70px;font-size:24px">{{ alldata.Contractorinfo.work_department1 }}</div>
          </div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:70px;font-size:24px">职 务</div>
            <div class="box justify-center" id="condition" style="width:500px;height:70px;font-size:24px">{{ alldata.Contractorinfo.postion1 }}</div>
          </div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:70px;font-size:24px">固定电话</div>
            <div class="box justify-center" id="condition" style="width:500px;height:70px;font-size:24px">{{ alldata.Contractorinfo.guding_phone1 }}</div>
          </div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:70px;font-size:24px">移动电话</div>
            <div class="box justify-center" id="condition" style="width:500px;height:70px;font-size:24px">{{ alldata.Contractorinfo.movephone11 }}</div>
          </div>
        </div>
      </div>
      <div class="th">
        <div class="box justify-center" style="width:220px;height:120px;font-size:24px;;">承建内容</div>
        <div class="box justify-center" id="condition" style="width:500px;height:120px;font-size:24px">{{ alldata.Contractorinfo.Construction_content1 }}</div>
      </div>
      <div class="th">
        <div
          class="box justify-center"
          style="width:70px;height:179px;font-size:24px"
        >
          项目
          <br />经理
        </div>
        <div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:61px;font-size:24px">姓 名</div>
            <div class="box justify-center" id="condition" style="width:500px;height:61px;font-size:24px">{{ alldata.Contractorinfo.name41 }}</div>
          </div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:60px;font-size:24px">持证等级</div>
            <div class="box justify-center" id="condition" style="width:500px;height:60px;font-size:24px">{{ alldata.Contractorinfo.leave1 }}</div>
          </div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:60px;font-size:24px">联系电话</div>
            <div class="box justify-center" id="condition" style="width:500px;height:60px;font-size:24px">{{ alldata.Contractorinfo.phone31 }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="a4">
      <span
        style="font-family:'仿宋';font-size:30px;line-height:40px;display:block;margin:20px 0 20px 0"
      >一、承建单位（申报单位）简况（续）</span>
      <div
        class="box"
        style="width:720px;height:1000px;text-align:start;font-size:24px;font-family:仿宋"
      >承建单位简介(500字以内)：{{ alldata.Contractorinfo.brief_introduction1 }}</div>
    </div>
    <div v-for="(item,index) in alldata.unitinfo" :key="index">
      <div class="a4">
      <span
        style="font-family:'仿宋';font-size:30px;display:block;margin:20px 0 20px 0"
      >二、参建单位简况</span>
      <div class="th">
        <div class="box justify-center" style="width:220px;height:60px;font-size:24px">单位名称</div>
        <div class="box justify-center" id="condition" style="width:220px;height:60px;font-size:24px">{{ item.unitname }}</div>
        <div class="box justify-center" style="width:120px;height:60px;font-size:24px">通信地址</div>
        <div class="box justify-center" id="condition" style="width:163px;height:60px;font-size:24px">{{ item.phoneaddress }}</div>
      </div>
      <div class="th">
        <div class="box justify-center" style="width:220px;height:60px;font-size:24px">邮政编码</div>
        <div class="box justify-center" id="condition" style="width:220px;height:60px;font-size:24px">{{ item.codeyouzheng }}</div>
        <div class="box justify-center" style="width:120px;height:60px;font-size:24px">联系电话</div>
        <div class="box justify-center" id="condition" style="width:163px;height:60px;font-size:24px">{{ item.Telephone }}</div>
      </div>
      <div class="th">
        <div class="box justify-center" style="width:220px;height:60px;font-size:24px">单位名称</div>
        <div class="box justify-center" id="condition" style="width:501px;height:60px;font-size:24px">{{ item.unitname }}</div>
      </div>
      <div class="th">
        <div
          class="box justify-center"
          style="width:70px;height:200px;font-size:24px"
        >
          法定
          <br />代表
          <br />人
        </div>
        <div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:101px;font-size:24px">姓 名</div>
            <div class="box justify-center" id="condition" style="width:500px;height:101px;font-size:24px">{{ item.name2 }}</div>
          </div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:100px;font-size:24px">联系电话</div>
            <div class="box justify-center" id="condition" style="width:500px;height:100px;font-size:24px">{{ item.phone2 }}</div>
          </div>
        </div>
      </div>
      <div class="th">
        <div
          class="box justify-center"
          style="width:70px;height:347px;font-size:24px"
        >
          申报
          <br />工作
          <br />联系
          <br />人
        </div>
        <div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:71px;font-size:24px">姓 名</div>
            <div class="box justify-center" id="condition" style="width:500px;height:71px;font-size:24px">{{ item.name3 }}</div>
          </div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:70px;font-size:24px">工作部门</div>
            <div class="box justify-center" id="condition" style="width:500px;height:70px;font-size:24px">{{ item.work_department }}</div>
          </div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:70px;font-size:24px">职 务</div>
            <div class="box justify-center" id="condition" style="width:500px;height:70px;font-size:24px">{{ item.postion }}</div>
          </div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:70px;font-size:24px">固定电话</div>
            <div class="box justify-center" id="condition" style="width:500px;height:70px;font-size:24px">{{ item.guding_phone }}</div>
          </div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:70px;font-size:24px">移动电话</div>
            <div class="box justify-center" id="condition" style="width:500px;height:70px;font-size:24px">{{ item.movephone1 }}</div>
          </div>
        </div>
      </div>
      <div class="th">
        <div class="box justify-center" style="width:220px;height:60px;font-size:24px">参建内容</div>
        <div class="box justify-center" id="condition" style="width:501px;height:60px;font-size:24px">{{ item.Construction_content }}</div>
      </div>
      <div class="th">
        <div class="box justify-center" style="width:220px;height:60px;font-size:24px">参建工作量</div>
        <div class="box justify-center" id="condition" style="width:501px;height:60px;font-size:24px">{{ item.Construction_workload }}</div>
      </div>
      <div class="th">
        <div class="box justify-center" style="width:220px;height:60px;font-size:24px">参建比例</div>
        <div class="box justify-center" id="condition" style="width:501px;height:60px;font-size:24px">{{ item.Construction_proportion }}</div>
      </div>
      <div class="th">
        <div
          class="box justify-center"
          style="width:70px;height:209px;font-size:24px"
        >
          项目
          <br />经理
        </div>
        <div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:71px;font-size:24px">姓 名</div>
            <div class="box justify-center" id="condition" style="width:500px;height:71px;font-size:24px">{{ item.name4 }}</div>
          </div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:70px;font-size:24px">持证等级</div>
            <div class="box justify-center" id="condition" style="width:500px;height:70px;font-size:24px">{{ item.leave }}</div>
          </div>
          <div class="th">
            <div class="box justify-center" style="width:151px;height:70px;font-size:24px">联系电话</div>
            <div class="box justify-center" id="condition" style="width:500px;height:70px;font-size:24px">{{ item.phone3 }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="a4">
      <span
        style="font-family:'仿宋';font-size:30px;line-height:40px;display:block;margin:20px 0 20px 0"
      >二、参建单位简况(续)</span>
      <div
        class="box"
        style="width:720px;height:1000px;text-align:start;font-size:24px;font-family:仿宋"
      >参建单位简介(200字以内): {{ item.brief_introduction }} </div>
    </div>
    </div>

    <div class="a4">
      <span
        style="font-family:'仿宋';font-size:30px;line-height:40px;display:block;margin:20px 0 20px 0"
      >二、参建单位简况（续）</span>
      <div class="box" style="width:720px;height:980px;text-align:start;padding:6px">
        <span style="font-family:仿宋;font-size:24px;line-height:40px">
          关于参建单位的说明：
          <br />
          <span style="display:inline-block;width:40px"></span> 本工程的参建奖由参建单位向承建单位提出申请，承建单位根据《贵州省黄果树杯优质工程评选办法》审查同意后,在申报黄果树杯时统一填报有关材料。承建单位是总负责单位，在黄果树杯申报、评审及获奖后涉及到的一切事宜，均由承建单位出面组织协调、统一对外联系。
          <br />
          <span style="display:inline-block;width:40px"></span> 特此说明。
        </span>
        <div
          style="position: relative;display:flex;width:600px;justify-content:space-around;font-size:24px;top:100px"
        >
          <p>承建单位：</p>
          <div>
            <p>盖 章</p>
            <br />
            <p>年 月 日</p>
          </div>
        </div>
        <div
          style="position: relative;display:flex;width:600px;justify-content:space-around;font-size:24px;top:300px"
        >
          <p>承建单位：</p>
          <div>
            <p>盖 章</p>
            <br />
            <p>年 月 日</p>
          </div>
        </div>
      </div>
    </div>
    <div class="a4">
      <span
        style="font-family:'仿宋';font-size:30px;line-height:40px;display:block;margin:20px 0 20px 0"
      >三、申报工程概况</span>
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">工程名称</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.Contractorinfo.projectNname }}</div>
      </div>
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">建设地点</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.Construction_site }}</div>
      </div>
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">工程类别</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.workscategory }}</div>
      </div>
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">使用功能</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.functi }}</div>
      </div>
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">建设规模</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.build }}</div>
      </div>
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">结构类型</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.structure }}</div>
      </div>
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">申报范围</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.declare }}</div>
      </div>
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">工程合同额</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.engineering }}</div>
      </div>
<!--      <div class="th">-->
<!--        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">工程决算额</div>-->
<!--        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.finalaccounts }}</div>-->
<!--      </div>-->
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">开工时间</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.worktime }}</div>
      </div>
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">竣工时间</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.becompleted }}</div>
      </div>
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">验收时间</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.acceptance }}</div>
      </div>
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">验收单位</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.acceptance_unit }}</div>
      </div>
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">勘察单位</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.survey_unit }}</div>
      </div>
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">建设单位</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.Construction_unit }}</div>
      </div>
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">使用单位</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.User_unit }}</div>
      </div>
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">设计单位</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.Design_unit }}</div>
      </div>
      <div class="th">
        <div class="box" style="width:200px;height:52px;line-height:52px;font-size:24px">监理单位</div>
        <div class="box" id="condition" style="width:521px;height:52px;line-height:52px;font-size:24px">{{ alldata.ProjectOverview.control_unit }}</div>
      </div>
    </div>
    <div class="a4">
      <span
        style="font-family:'仿宋';font-size:30px;line-height:40px;display:block;margin:20px 0 20px 0"
      >三、申报工程概况（续）</span>
      <div
        class="box"
        style="width:720px;height:1000px;text-align:start;font-size:24px;font-family:仿宋"
      >工程简介（800字以内）：{{ alldata.ProjectOverview.project_info }}</div>
    </div>
    <div class="a4">
      <span
        style="font-family:'仿宋';font-size:30px;line-height:40px;display:block;margin:20px 0 20px 0"
      >四、申报理由</span>
      <div
        class="box"
        style="width:720px;height:1000px;text-align:start;font-size:24px;font-family:仿宋"
      >参照申报条件阐述理由：{{ alldata.Explain_the_reason }}</div>
    </div>
    <div class="a4">
      <span
        style="font-family:'仿宋';font-size:30px;line-height:40px;display:block;margin:20px 0 20px 0"
      >五、有关单位意见</span>
      <div
        class="box"
        style="width:720px;height:1000px;text-align:start;font-size:24px;font-family:仿宋;padding:0 10px"
      >
        建设单位意见：
        <div style="height:500px;margin-top:20px">1、意见综述 <span>{{ alldata.Opinion_summary?alldata.Opinion_summary.value:'' }}</span></div>
        <div style="height:400px;position: relative;">
          2、总体满意程度评价（非常满意、满意、比较满意）
          <span>{{ alldata.isOpinion_summary }}</span>
          <div style="position: absolute;right:100px;bottom:50px">
            <p>单位公章</p>
            <br />
            <p>年 月 日</p>
          </div>
        </div>
      </div>
    </div>
    <div class="a4">
      <span
        style="font-family:'仿宋';font-size:30px;line-height:40px;display:block;margin:20px 0 20px 0"
      >五、有关单位意见（续）</span>
      <div
        class="box"
        style="width:720px;height:1000px;text-align:start;font-size:24px;font-family:仿宋;padding:0 10px"
      >
        使用单位意见：
        <div style="height:500px;margin-top:20px">1、意见综述 <span>{{ alldata.use?alldata.use.value:'' }}</span></div>
        <div style="height:400px;position: relative;">
          2、总体满意程度评价（非常满意、满意、比较满意）
          <div style="position: absolute;right:100px;bottom:50px">
            <p>单位公章</p>
            <br />
            <p>年 月 日</p>
          </div>
        </div>
      </div>
    </div>
    <div class="a4">
      <span
        style="font-family:'仿宋';font-size:30px;line-height:40px;display:block;margin:20px 0 20px 0"
      >五、有关单位意见（续）</span>
      <div
        class="box"
        style="width:720px;height:1000px;text-align:start;font-size:24px;font-family:仿宋;padding:0 10px"
      >
        设计单位意见：
        <div style="height:500px;margin-top:20px">1、意见综述 <span>{{ alldata.Design?alldata.Design.value:'' }}</span></div>
        <div style="height:400px;position: relative;">
          2、总体满意程度评价（非常满意、满意、比较满意）
          <div style="position: absolute;right:100px;bottom:50px">
            <p>单位公章</p>
            <br />
            <p>年 月 日</p>
          </div>
        </div>
      </div>
    </div>
    <div class="a4">
      <span
        style="font-family:'仿宋';font-size:30px;line-height:40px;display:block;margin:20px 0 20px 0"
      >五、有关单位意见（续）</span>
      <div
        class="box"
        style="width:720px;height:1000px;text-align:start;font-size:24px;font-family:仿宋;padding:0 10px"
      >
        监理单位意见：
        <div style="height:500px;margin-top:20px">1、意见综述 <span>{{ alldata.supervisor?alldata.supervisor.value:'' }}</span></div>
        <div style="height:400px;position: relative;">
          2、总体满意程度评价（非常满意、满意、比较满意）
          <div style="position: absolute;right:100px;bottom:50px">
            <p>单位公章</p>
            <br />
            <p>年 月 日</p>
          </div>
        </div>
      </div>
    </div>
    <div class="a4">
      <span
        style="font-family:'仿宋';font-size:30px;line-height:40px;display:block;margin:20px 0 20px 0"
      >五、有关单位意见（续）</span>
      <div
        class="box"
        style="width:720px;height:1000px;text-align:start;font-size:24px;font-family:仿宋;padding:0 10px"
      >
        推荐单位意见：
        <div style="height:500px;margin-top:20px">1、意见综述 <span>{{ alldata.Reasons?alldata.Reasons.value:'' }}</span></div>
        <div style="height:400px;position: relative;">
          2、总体满意程度评价（非常满意、满意、比较满意）
          <div style="position: absolute;right:100px;bottom:50px">
            <p>单位公章</p>
            <br />
            <p>年 月 日</p>
          </div>
        </div>
      </div>
    </div>
      <!-- <div class="zhengshu" v-for="(item,index) in pdfandimg" :key="index">
        <h1 style="font-size:28px;margin:0 0 14px 0">{{ item.title }}</h1>
        <pdf ref="pdf" v-for="i in item.Pages" :key="i" :page="i" :src="item.url" v-show="item.state==true"></pdf>
        <div v-if="item.state==false" class="a4">
          <img width="100%" :src="item.url" alt="">
        </div>
      </div> -->

    <!-- <VueDocPreview v-if="url!=''" class="a4" height="1250" :url="url" type="office" :mdStyle="mdStyle" /> -->

    <iframe v-if="url!=null" :src="url" width='841px' height='1189px' frameborder='0'></iframe>

    <div class="a3">
      <div class="a3-box">
      <div class="box" style="height:50px;width:1094px">
        <h1 style="font-size:24px;margin:0;line-height:50px">2021年度贵州省黄果树杯优质工程申报汇总表</h1>
      </div>
      <div class="box" style="width:1094px;height:50px;display:flex;justify-content:space-between;align-items:center;padding:0 10px">
        <span>申报单位：（全称加盖公章）</span>
        <span style="margin-right:200px">填表人及电话：</span>
      </div>
      <div class="th">
        <div class="box justify-center" style="height:100px;width:41px">序号</div>
        <div class="box justify-center" style="height:100px;width:100px">工程名称</div>
        <div class="box justify-center" style="height:100px;width:160px">承建单位及获奖人员</div>
        <div class="box justify-center" style="height:100px;width:160px">主要参建单位及获奖人员</div>
        <div class="box justify-center" style="height:100px;width:160px">建设单位及主要负责人</div>
        <div class="box justify-center" style="height:100px;width:160px">设计单位及主要负责人</div>
        <div class="box justify-center" style="height:100px;width:160px">质量监督单位及主要负责人</div>
        <div class="box justify-center" style="height:100px;width:160px">监理单位及总监工程师</div>
      </div>
      <div class="th">
        <div class="box justify-center" style="height:140px;width:41px">例</div>
        <div class="box justify-center" style="height:140px;width:100px">贵州省地质资料馆暨地质博物馆建设项目</div>
        <div class="box justify-center" style="height:140px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:72px;font-size:16px;text-align:start">承建单位：中铁五局集团建筑工程有限责任公司</div>
            <div class="box justify-start" style="width:160px;height:35px;font-size:16px;text-align:start">工程项目经理：刘建海 </div>
            <div class="box justify-start" style="width:160px;height:35px;font-size:16px;text-align:start">工程技术负责人：陈代龙</div>
          </div>
        </div>
        <div class="box justify-center" style="height:140px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:72px;font-size:16px;text-align:start">参建单位：贵州飞大装饰有限公司</div>
            <div class="box justify-start" style="width:160px;height:35px;font-size:16px;text-align:start">工程项目经理：田进 </div>
            <div class="box justify-start" style="width:160px;height:35px;font-size:16px;text-align:start">工程技术负责人：李小保</div>
          </div>
        </div>
        <div class="box justify-center" style="height:140px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:72px;font-size:16px;text-align:start">建设单位：贵州省自然资源厅</div>
            <div class="box justify-start" style="width:160px;height:69px;font-size:16px;text-align:start">主要负责人：袁景国 </div>
          </div>
        </div>
        <div class="box justify-center" style="height:140px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:72px;font-size:16px;text-align:start">设计单位：贵州省建筑设计研究院有限责任公司</div>
            <div class="box justify-start" style="width:160px;height:69px;font-size:16px;text-align:start">主要负责人：代宁 </div>
          </div>
        </div>
        <div class="box justify-center" style="height:140px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:72px;font-size:16px;text-align:start">质量监督单位：贵阳市观山湖区建设工程质量监督站</div>
            <div class="box justify-start" style="width:160px;height:69px;font-size:16px;text-align:start">主要负责人：黄明岗 </div>
          </div>
        </div>
        <div class="box justify-center" style="height:140px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:72px;font-size:16px;text-align:start">监理单位：贵州省建筑设计研究院有限责任公司</div>
            <div class="box justify-start" style="width:160px;height:69px;font-size:16px;text-align:start">工程总监：赵应虎 </div>
          </div>
        </div>
      </div>
      <div class="th">
        <div class="box justify-center" style="height:260px;width:41px">1</div>
        <div class="box justify-center" style="height:260px;width:100px">{{ alldata.Contractorinfo.projectNname }}</div>
        <div class="box justify-center" style="height:260px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:111px;font-size:16px;text-align:start">承建单位:{{ alldata.Contractorinfo.ReportingUnit }}</div>
            <div class="box justify-start" style="width:160px;height:115px;font-size:16px;text-align:start">工程项目经理:{{ alldata.Contractorinfo.name41 }}</div>
            <div class="box justify-start" style="width:160px;height:35px;font-size:16px;text-align:start">工程技术负责人:{{ alldata.DeclarationSummary.Technicaldirector }}</div>
          </div>
        </div>
        <div class="box justify-center" style="height:260px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box " style="width:160px;height:111px;font-size:16px;text-align:start">参建单位: <p v-for="(item,index) in alldata.unitinfo" :key="index">{{ item.unitname }}</p> </div>
            <div class="box " style="width:160px;height:115px;font-size:16px;text-align:start">工程项目经理:<p v-for="(item,index) in alldata.unitinfo" :key="index">{{ item.name4 }} </p> </div>
            <div class="box justify-start" style="width:160px;height:35px;font-size:16px;text-align:start">工程技术负责人:{{ alldata.DeclarationSummary.engineering }}</div>
          </div>
        </div>
        <div class="box justify-center" style="height:260px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:111px;font-size:16px;text-align:start">建设单位：{{ alldata.ProjectOverview.Construction_unit }}厅</div>
            <div class="box justify-start" style="width:160px;height:149px;font-size:16px;text-align:start">主要负责人： {{ alldata.DeclarationSummary.Construction_unit }}</div>
          </div>
        </div>
        <div class="box justify-center" style="height:260px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:111px;font-size:16px;text-align:start">设计单位：{{ alldata.ProjectOverview.Design_unit }}</div>
            <div class="box justify-start" style="width:160px;height:149px;font-size:16px;text-align:start">主要负责人： {{ alldata.DeclarationSummary.Design_unit }}</div>
          </div>
        </div>
        <div class="box justify-center" style="height:260px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:111px;font-size:16px;text-align:start">质量监督单位：{{ alldata.DeclarationSummary.supervisionunit }}</div>
            <div class="box justify-start" style="width:160px;height:149px;font-size:16px;text-align:start">工程总监： {{ alldata.DeclarationSummary.Principaloftheunit }}</div>
          </div>
        </div>
        <div class="box justify-center" style="height:260px;width:160px">
          <div style="display:flex;flex-direction: column;margin:0 1px 1px 0;width:160px;">
            <div class="box justify-start" style="width:160px;height:111px;font-size:16px;text-align:start">监理单位：{{ alldata.ProjectOverview.control_unit }}</div>
            <div class="box justify-start" style="width:160px;height:149px;font-size:16px;text-align:start">工程总监： {{ alldata.DeclarationSummary.Chiefengineer }}</div>
          </div>
        </div>
      </div>
      <div class="th">
        <dib class="box justify-start" style="height:80px;width:1094px">
          （填表说明：请申报单位属实填写，各单位相应人员仅填报一人，核对确认后加盖公司公章，如有错漏不再进行更改。请不要改变表格格式，将此表格纸质版加盖公章和Excel电子版随同申报资料一并报到黄果树杯评选办公室。）
        </dib>
      </div>

      </div>
    </div>
    <div class="a3" style="height:1250px;">
      <div class="a3-box">
      <div class="box" style="height:50px;width:1190px">
        <h1 style="font-size:24px;margin:0;line-height:50px">2021年度贵州省黄果树杯优质工程申报登记表</h1>
      </div>
      <div class="box" style="height:50px;width:1190px;display:flex;justify-content:space-between;align-items:center;">
        <span>申报单位：（盖章）</span>
        <span style="margin-right:400px">推荐单位：（盖章）</span>
      </div>
      <div class="th">
        <div class="box justify-center" style="width:20px;height:190px">序号</div>
        <div class="box justify-center" style="width:34px;height:190px">工程名称</div>
        <div class="box justify-center" style="width:34px;height:190px">申报单位</div>
        <div class="box justify-center" style="width:50px;height:190px">工程类别（住宅工程、公共建筑工程、市政园林工程）</div>
        <div class="box justify-center" style="width:34px;height:190px">项目详细地址</div>
        <div class="box justify-center" style="width:34px;height:190px">申报联系人</div>
        <div class="box justify-center" style="width:34px;height:190px">手机号码</div>
        <div class="box justify-center" style="width:34px;height:190px">申报联系人邮箱</div>
        <div class="box justify-center" style="width:34px;height:190px">工程规模</div>
        <div class="box justify-center" style="width:34px;height:190px">工程竣工时间</div>
        <div class="box justify-center" style="width:34px;height:190px">推荐单位联系人及电话</div>
        <div class="box justify-center" style="width:34px;height:190px">推荐单位</div>
        <div class="box justify-center" style="width:34px;height:190px">工程立项复批</div>
        <div class="box justify-center" style="width:34px;height:190px">土地使用证</div>
        <div class="box justify-center" style="width:34px;height:190px">建设工程规划许可证</div>
        <div class="box justify-center" style="width:34px;height:190px">工程创优策划书</div>
        <div class="box justify-center" style="width:34px;height:190px">工程施工图设计文件审查合格书或审批文件</div>
        <div class="box justify-center" style="width:34px;height:190px">工程施工合同</div>
        <div class="box justify-center" style="width:34px;height:190px">施工许可证或批准开工报告</div>
        <div class="box justify-center" style="width:34px;height:190px">建设工程消防验收意见书(涉及消防工程)</div>
        <div class="box justify-center" style="width:34px;height:190px">工程“竣工验收报告”</div>
        <div class="box justify-center" style="width:34px;height:190px">“投入使用时间和使用效果证明”(建设单位出具)</div>
        <div class="box justify-center" style="width:47px;height:190px">“建筑业10项新技术应用证明”(监理单位出具)</div>
        <div class="box justify-center" style="width:70px;height:190px">工业交通水利工程其“技术指标、经济效益及社会效益应达到本专业工程省内领先水平证明”</div>
        <div class="box justify-center" style="width:50px;height:190px">建筑业新技术应用示范工程或绿色施工示范工程证书</div>
        <div class="box justify-center" style="width:34px;height:190px">“贵州省建筑工程优质质量结构工程”评定文件</div>
        <div class="box justify-center" style="width:34px;height:190px">“贵州省建筑安全文明施工样板工地”评定文件</div>
          <div class="box justify-center" style="width:34px;height:190px">无质量安全事故承诺</div>
          <div class="box justify-center" style="width:34px;height:190px">无质量安全事故承诺补充材料</div>
          <div class="box justify-center" style="width:34px;height:190px">无拖欠农民工工资承诺</div>
          <div class="box justify-center" style="width:34px;height:190px">无拖欠农民工工资承诺补充材料</div>
          <div class="box justify-center" style="width:34px;height:190px">反映工程概况和质量状况的彩色照片15张</div>
          <div class="box justify-center" style="width:34px;height:190px">5分钟工程影响资料</div>
          <div class="box justify-center" style="width:34px;height:190px">贵州省“黄果树杯”优质工程申报表</div>

<!--        <div class="box justify-center" style="width:50px;height:190px">建筑业10项新技术推广应用证明或绿色施工证明</div>-->
<!--        <div class="box justify-center" style="width:50px;height:190px">省优质主体结构工程创优奖（住宅工程、公共建筑工程、市政桥梁工程）</div>-->
<!--        <div class="box justify-center" style="width:50px;height:190px">省安全文明样板工地奖（住宅工程、公共建筑工程、市政园林工程）</div>-->
      </div>
      <div class="th">
        <div class="box justify-center" style="width:20px;height:190px">1</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.Contractorinfo.projectNname }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.Contractorinfo.ReportingUnit }}</div>
        <div class="box justify-center" style="width:50px;height:190px">{{ alldata.ProjectOverview.workscategory }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.ProjectOverview.Construction_site }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.Contractorinfo.name31 }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.Contractorinfo.movephone11 }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.Contractorinfo.Postal1 }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.ProjectOverview.build }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.ProjectOverview.becompleted }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.Unitcontact }}{{ alldata.SupplementaryContent.contactnumber }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.Contractorinfo.RecommendedUnit }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is1?(alldata.SupplementaryContent.is1=='0'?'无':'有'):'无' }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is2?(alldata.SupplementaryContent.is2=='0'?'无':'有'):'无' }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is3?(alldata.SupplementaryContent.is3=='0'?'无':'有'):'无' }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is4?(alldata.SupplementaryContent.is4=='0'?'无':'有'):'无' }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is5?(alldata.SupplementaryContent.is5=='0'?'无':'有'):'无' }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is6?(alldata.SupplementaryContent.is6=='0'?'无':'有'):'无' }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is7?(alldata.SupplementaryContent.is7=='0'?'无':'有'):'无' }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is8?(alldata.SupplementaryContent.is8=='0'?'无':'有'):'无' }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is9?(alldata.SupplementaryContent.is9=='0'?'无':'有'):'无' }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is10?(alldata.SupplementaryContent.is10=='0'?'无':'有'):'无' }}</div>
        <div class="box justify-center" style="width:47px;height:190px">{{ alldata.SupplementaryContent.is11?(alldata.SupplementaryContent.is11=='0'?'无':'有'):'无' }}</div>
        <div class="box justify-center" style="width:70px;height:190px">{{ alldata.SupplementaryContent.is12?(alldata.SupplementaryContent.is12=='0'?'无':'有'):'无' }}</div>
        <div class="box justify-center" style="width:50px;height:190px">{{ alldata.SupplementaryContent.is13?(alldata.SupplementaryContent.is13=='0'?'无':'有'):'无' }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is14?(alldata.SupplementaryContent.is14=='0'?'无':'有'):'无' }}</div>
        <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is15?(alldata.SupplementaryContent.is15=='0'?'无':'有'):'无' }}</div>
          <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is16?(alldata.SupplementaryContent.is16=='0'?'无':'有'):'无' }}</div>
          <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is17?(alldata.SupplementaryContent.is17=='0'?'无':'有'):'无' }}</div>
          <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is18?(alldata.SupplementaryContent.is18=='0'?'无':'有'):'无' }}</div>
          <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is19?(alldata.SupplementaryContent.is19=='0'?'无':'有'):'无' }}</div>
          <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is20?(alldata.SupplementaryContent.is20=='0'?'无':'有'):'无' }}</div>
          <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is21?(alldata.SupplementaryContent.is21=='0'?'无':'有'):'无' }}</div>
          <div class="box justify-center" style="width:34px;height:190px">{{ alldata.SupplementaryContent.is22?(alldata.SupplementaryContent.is22=='0'?'无':'有'):'无' }}</div>
<!--        <div class="box justify-center" style="width:50px;height:190px">{{ alldata.SupplementaryContent.certificate.length?alldata.SupplementaryContent.certificate[0].uploadlist.length == 0?'无':'有':'无' }}</div>-->
<!--        <div class="box justify-center" style="width:50px;height:190px">{{ alldata.SupplementaryContent.Architecture_msg2_file.length == 0?'无':'有' }}</div>-->
<!--        <div class="box justify-center" style="width:50px;height:190px">{{ alldata.SupplementaryContent.Architecture_msg3_file.length == 0?'无':'有' }}</div>-->
      </div>
      <div class="th">
        <div class="box justify-center" style="width:20px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:50px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:47px;height:190px"></div>
        <div class="box justify-center" style="width:70px;height:190px"></div>
        <div class="box justify-center" style="width:50px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
        <div class="box justify-center" style="width:34px;height:190px"></div>
          <div class="box justify-center" style="width:34px;height:190px"></div>
          <div class="box justify-center" style="width:34px;height:190px"></div>
          <div class="box justify-center" style="width:34px;height:190px"></div>
      </div>
    </div>
    </div>
  </div>
  <div class="a3">
      <div class="th">
        <div class="box justify-center" style="width:55px;height:200px">工程立项复批</div>
        <div class="box justify-center" style="width:55px;height:200px">土地使用证</div>
        <div class="box justify-center" style="width:55px;height:200px">建设工程规划许可证</div>
        <div class="box justify-center" style="width:55px;height:200px">工程创优策划书</div>
        <div class="box justify-center" style="width:55px;height:200px">工程施工图设计文件审查合格书或审批文件</div>
        <div class="box justify-center" style="width:30px;height:200px">工程施工合同</div>
        <div class="box justify-center" style="width:55px;height:200px">施工许可证或批准开工报告</div>
        <div class="box justify-center" style="width:55px;height:200px">建设工程消防验收意见书</div>
        <div class="box justify-center" style="width:55px;height:200px">工程“竣工验收报告”</div>
        <div class="box justify-center" style="width:55px;height:200px">“投入使用时间和使用效果证明”</div>
        <div class="box justify-center" style="width:55px;height:200px">“建筑业10项新技术应用证明”</div>
        <div class="box justify-center" style="width:80px;height:200px">工业交通水利工程其“技术指标、经济效益及社会效益应达到本专业工程省内领先水平证明”</div>
        <div class="box justify-center" style="width:40px;height:200px">建筑业新技术应用示范工程或绿色施工示范工程证书</div>
        <div class="box justify-center" style="width:40px;height:200px">“贵州省建筑工程优质质量结构工程”评定文件</div>
        <div class="box justify-center" style="width:40px;height:200px">“贵州省建筑安全文明施工样板工地”评定文件</div>
        <div class="box justify-center" style="width:40px;height:200px">无质量安全事故承诺</div>
        <div class="box justify-center" style="width:40px;height:200px">无质量安全事故承诺补充材料</div>
        <div class="box justify-center" style="width:40px;height:200px">无拖欠农民工工资承诺</div>
          <div class="box justify-center" style="width:40px;height:200px">无拖欠农民工工资承诺补充材料</div>
          <div class="box justify-center" style="width:40px;height:200px">反映工程概况和质量状况的彩色照片15张</div>
          <div class="box justify-center" style="width:40px;height:200px">5分钟工程影响资料</div>
          <div class="box justify-center" style="width:40px;height:200px">贵州省“黄果树杯”优质工程申报表</div>
      </div>
      <div class="th">
        <div class="box justify-center"  style="width:55px;height:200px"><a v-if="alldata.SupplementaryContent.is1=='1'&&alldata.SupplementaryContent.is1arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is1arr[0].response.data.host+alldata.SupplementaryContent.is1arr[0].response.data.url">有</a></div>
        <div class="box justify-center"  style="width:55px;height:200px"><a v-if="alldata.SupplementaryContent.is2=='1'&&alldata.SupplementaryContent.is2arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is2arr[0].response.data.host+alldata.SupplementaryContent.is2arr[0].response.data.url">有</a></div>
        <div class="box justify-center"  style="width:55px;height:200px"><a v-if="alldata.SupplementaryContent.is3=='1'&&alldata.SupplementaryContent.is3arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is3arr[0].response.data.host+alldata.SupplementaryContent.is3arr[0].response.data.url">有</a></div>
        <div class="box justify-center"  style="width:55px;height:200px"><a v-if="alldata.SupplementaryContent.is4=='1'&&alldata.SupplementaryContent.is4arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is4arr[0].response.data.host+alldata.SupplementaryContent.is4arr[0].response.data.url">有</a></div>
        <div class="box justify-center"  style="width:55px;height:200px"><a v-if="alldata.SupplementaryContent.is5=='1'&&alldata.SupplementaryContent.is5arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is5arr[0].response.data.host+alldata.SupplementaryContent.is5arr[0].response.data.url">有</a></div>
        <div class="box justify-center"  style="width:30px;height:200px"><a v-if="alldata.SupplementaryContent.is6=='1'&&alldata.SupplementaryContent.is6arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is6arr[0].response.data.host+alldata.SupplementaryContent.is6arr[0].response.data.url">有</a></div>
        <div class="box justify-center"  style="width:55px;height:200px"><a v-if="alldata.SupplementaryContent.is7=='1'&&alldata.SupplementaryContent.is7arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is7arr[0].response.data.host+alldata.SupplementaryContent.is7arr[0].response.data.url">有</a></div>
        <div class="box justify-center"  style="width:55px;height:200px"><a v-if="alldata.SupplementaryContent.is8=='1'&&alldata.SupplementaryContent.is8arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is8arr[0].response.data.host+alldata.SupplementaryContent.is8arr[0].response.data.url">有</a></div>
        <div class="box justify-center"  style="width:55px;height:200px"><a v-if="alldata.SupplementaryContent.is9=='1'&&alldata.SupplementaryContent.is9arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is9arr[0].response.data.host+alldata.SupplementaryContent.is9arr[0].response.data.url">有</a></div>
        <div class="box justify-center"  style="width:55px;height:200px"><a v-if="alldata.SupplementaryContent.is10=='1'&&alldata.SupplementaryContent.is10arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is10arr[0].response.data.host+alldata.SupplementaryContent.is10arr[0].response.data.url">有</a></div>
        <div class="box justify-center"  style="width:55px;height:200px"><a v-if="alldata.SupplementaryContent.is11=='1'&&alldata.SupplementaryContent.is11arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is11arr[0].response.data.host+alldata.SupplementaryContent.is11arr[0].response.data.url">有</a></div>
        <div class="box justify-center"  style="width:80px;height:200px"><a v-if="alldata.SupplementaryContent.is12=='1'&&alldata.SupplementaryContent.is12arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is12arr[0].response.data.host+alldata.SupplementaryContent.is12arr[0].response.data.url">有</a></div>
        <div class="box justify-center"  style="width:40px;height:200px"><a v-if="alldata.SupplementaryContent.is13=='1'&&alldata.SupplementaryContent.is13arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is13arr[0].response.data.host+alldata.SupplementaryContent.is13arr[0].response.data.url">有</a></div>
        <div class="box justify-center"  style="width:40px;height:200px"><a v-if="alldata.SupplementaryContent.is14=='1'&&alldata.SupplementaryContent.is14arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is14arr[0].response.data.host+alldata.SupplementaryContent.is14arr[0].response.data.url">有</a></div>
        <div class="box justify-center"  style="width:40px;height:200px"><a v-if="alldata.SupplementaryContent.is15=='1'&&alldata.SupplementaryContent.is15arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is15arr[0].response.data.host+alldata.SupplementaryContent.is15arr[0].response.data.url">有</a></div>
          <div class="box justify-center"  style="width:40px;height:200px"><a v-if="alldata.SupplementaryContent.is16=='1'&&alldata.SupplementaryContent.is16arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is16arr[0].response.data.host+alldata.SupplementaryContent.is16arr[0].response.data.url">有</a></div>
          <div class="box justify-center"  style="width:40px;height:200px"><a v-if="alldata.SupplementaryContent.is17=='1'&&alldata.SupplementaryContent.is17arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is17arr[0].response.data.host+alldata.SupplementaryContent.is17arr[0].response.data.url">有</a></div>
          <div class="box justify-center"  style="width:40px;height:200px"><a v-if="alldata.SupplementaryContent.is18=='1'&&alldata.SupplementaryContent.is18arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is18arr[0].response.data.host+alldata.SupplementaryContent.is18arr[0].response.data.url">有</a></div>
          <div class="box justify-center"  style="width:40px;height:200px"><a v-if="alldata.SupplementaryContent.is19=='1'&&alldata.SupplementaryContent.is19arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is19arr[0].response.data.host+alldata.SupplementaryContent.is19arr[0].response.data.url">有</a></div>
          <div class="box justify-center"  style="width:40px;height:200px"><a v-if="alldata.SupplementaryContent.is20=='1'&&alldata.SupplementaryContent.is20arr[0].response" target="_blank" @click="dialogTableVisible = true">有</a></div>
          <div class="box justify-center"  style="width:40px;height:200px"><a v-if="alldata.SupplementaryContent.is21=='1'&&alldata.SupplementaryContent.is21arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is21arr[0].response.data.host+alldata.SupplementaryContent.is21arr[0].response.data.url">有</a></div>
          <div class="box justify-center"  style="width:40px;height:200px"><a v-if="alldata.SupplementaryContent.is22=='1'&&alldata.SupplementaryContent.is22arr[0].response" target="_blank" :href="alldata.SupplementaryContent.is22arr[0].response.data.host+alldata.SupplementaryContent.is22arr[0].response.data.url">有</a></div>
<!--        <div class="box justify-center"  style="width:55px;height:200px;flex-direction: column;"><a v-for="(item,index) in alldata.SupplementaryContent.certificate" :key="index" v-show="alldata.SupplementaryContent.certificate[0].uploadlist.length!=0" target="_blank" :href="item.uploadlist[0].url">有</a></div>-->
<!--        <div class="box justify-center"  style="width:55px;height:200px"><a v-if="alldata.SupplementaryContent.Architecture_msg2_file.length!=0" target="_blank" :href="alldata.SupplementaryContent.Architecture_msg2_file[0].url">有</a></div>-->
<!--        <div class="box justify-center"  style="width:55px;height:200px"><a v-if="alldata.SupplementaryContent.Architecture_msg3_file.length!=0" target="_blank" :href="alldata.SupplementaryContent.Architecture_msg3_file[0].url">有</a></div>-->
      </div>
  </div>

    <el-dialog  title="反映工程概况和质量状况的彩色照片15张" :visible.sync="dialogTableVisible" center="true">
        <div class="demo-image__lazy" >
            <el-image v-for="item in alldata.SupplementaryContent.is20arr" :key="item['uid']" :src="item.response.data.host+item.response.data.url" lazy></el-image>
        </div>
    </el-dialog>
</div>
</template>
<script>
import PDF from 'pdfjs-dist/legacy/build/pdf.js'
import self_adaption from './adaption'
import '../word/pdfview.less'
import JsPDF from 'jspdf'
export default {
    components: {
      // VueDocPreview,
      // pdf
    },
  props:{
    alldata:{
      type:Object
    }
  },
  data() {
    return {
      width: 100,
      pdfDoc: null,
      pages: 0,
      mdStyle:{

      },
      pdfandimg:[],
      loadingTask:"",
      numPages:null,
      url:null,
      xiahuaxian:
        "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
        dialogTableVisible:false
    };
  },
  created(){
      setTimeout(() => {
        if (this.alldata.Recommendationform&&this.alldata.Recommendationform!=""&&this.alldata.Recommendationform.length>0){
          this.url = this.alldata.Recommendationform[0].response.data.host+this.alldata.Recommendationform[0].response.data.url
        }else{
          this.url = null
        }
      }, 500);
  },
  mounted(){
    self_adaption()
    console.log(852,this.$refs.previewDom);
    this.$emit('previewDom',this.$refs.previewDom)//整页DOM上传至父组件
    // this.getNumPages()

  },
  methods:{
    renderPage (num) {
      this.pdfDoc.getPage(num)
        .then((page) => {
          let canvas = document.getElementById('canvas' + num)
          let ctx = canvas.getContext('2d')
          let dpr = window.devicePixelRatio || 1 // 设备像素比
          let bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1 // 浏览器在渲染canvas之前会用几个像素来来存储画布信息,类似img
          let ratio = dpr / bsr
          let viewport = page.getViewport(1.5)
          canvas.width = viewport.width * ratio // 画布大小,默认值是width:300px,height:150px
          canvas.height = viewport.height * ratio
          canvas.style.width = viewport.width + 'px' // 画布的框架大小
          canvas.style.height = viewport.height + 'px'
          let renderContext = {
            canvasContext: ctx,
            viewport: viewport
          }
          page.render(renderContext)
          if (this.pages > num) {
            this.renderPage(num + 1)
          } else {
            this.closeServerLoadingHandle()
          }
        })
    },
    fn(){
      let PDF = new JsPDF('', 'pt', 'a4')
    },
    //pdf预览分页
    // getNumPages() {
    //   let arr = []
    //   Object.defineProperty(this.alldata.SupplementaryContent, "certificate", {
    //           get : function() {return null},
    //           enumberable : false
    //   });
    //   for (const key in this.alldata.SupplementaryContent) {
    //     if (typeof this.alldata.SupplementaryContent[key] == 'string' || this.alldata.SupplementaryContent[key] == null) {
    //       console.log();
    //     }else{
    //       this.alldata.SupplementaryContent[key][0].url = this.alldata.SupplementaryContent[key][0].response.data.host+this.alldata.SupplementaryContent[key][0].response.data.url
    //       arr.push(
    //         {
    //           Pages:1,
    //           title:this.alldata.SupplementaryContent[key][0].title,
    //           url:this.alldata.SupplementaryContent[key][0].url
    //         }
    //       )
    //     }
    //   }

    //   let url,num,name
    //   for (let i = 0; i < arr.length; i++) {
    //     url = arr[i].url
    //     num = url.length-3
    //     name = url.substring(num)
    //     if (name=='pdf'||name == 'PDF') {
    //       this.loadingTask = pdf.createLoadingTask(arr[i].url)
    //       this.loadingTask.promise.then(pdf => {
    //         arr[i].Pages = pdf.numPages
    //         arr[i].state = true
    //       }).catch(err => {
    //         console.error('pdf 加载失败', err);
    //       })
    //     }else{
    //       arr[i].state = false
    //     }
    //   }
    //   this.pdfandimg = arr

    // },
  }
};
</script>

<style lang="less" scoped>
.word_5{

  width: 841px;
  margin: 0 auto;
}
</style>
